import api from './api';

/* La schermata «Oggi» (proposta 26, fase 2): la giornata in una chiamata
   (backend/controllers/oggiController.js), con la vista se e' stata scelta,
   e i compiti urgenti dalla rotta dei compiti (compitiController.urgenti). */
export const oggiAPI = {
    giornata: (vista) => api.get('/oggi', { params: vista ? { vista } : {} }),
    compitiUrgenti: () => api.get('/compiti/urgenti'),
};

export default oggiAPI;
